import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import eshop from "../../Assets/Projects/eshop.png";
import flappybird from "../../Assets/Projects/flappy-bird.webp";
import kbs from "../../Assets/Projects/kbs.PNG";
import sems from "../../Assets/Projects/sems.png";
import ncr from "../../Assets/Projects/ncr.webp";
import lan from "../../Assets/Projects/iitlogo.jpeg";
import ums from "../../Assets/Projects/schoolmanager.png";
import recruitment from "../../Assets/Projects/hrm.PNG";
import robi from "../../Assets/Projects/robiairtel.PNG";
import newsportal from "../../Assets/Projects/newsportal.png";
import streamz from "../../Assets/Projects/streamz.png";
import myproperty from "../../Assets/Projects/myproperty.png";
import bi_bot from "../../Assets/Projects/bi_bot.png";
import apache_superset from "../../Assets/Projects/apache_superset.jpg";
import automation from "../../Assets/Projects/automation.jpg";
import group_judge from "../../Assets/Projects/group_judge.png";
import sports_highlight from "../../Assets/Projects/sports_highlight.jpg";
import interest_detection from "../../Assets/Projects/Interest_detection.png";
import osaka_expo from "../../Assets/Projects/osaka_expo.jpeg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Few Projects Overview </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sports_highlight}
              isBlog={false}
              title="AI-Based Sports/Events Highlight Generator"
              description="This project focuses on developing an AI-driven system that automatically detects exciting moments from various types of video footage—such as sports, concerts, and daily life events—and generates short highlight videos enhanced with dynamic animations. A dedicated mobile application allows users to either record videos directly or upload existing footage from their device storage. If the system identifies any highlight-worthy moments in the uploaded video, users are rewarded with incentives (e.g., points or monetary rewards), encouraging active participation.

              Key Features:
              #Data Collection & Annotation: Gathered diverse video content from mobile uploads, live streams, and/or publicly shared videos. Videos were processed into frames and annotated with detailed action labels such as dangerous tackle, spike, jump, block, goal, foul, celebration, emotional reaction, hugging, funny moments, and more.

              #Object & Action Detection: Trained a YOLO-based deep learning model to accurately detect specific objects and human actions within video frames, enabling real-time analysis.

              #Highlight Identification: The model continuously infers actions and autonomously detects high-interest segments based on a set of predefined action classes, ensuring relevance and excitement.

              #Smart Video Editing: Once an exciting moment is detected, the system automatically trims the corresponding footage and enhances it with intelligent editing techniques—such as zoom effects, cropping, and graphic overlays—to create engaging, shareable highlight clips. 
              
              *Technologies used in the project - Python, OpenCV, YOLO, MMAction, Azure Event Hubs with Kafka, Azure Machine Learning, Azure Blob Storage, Azure Databricks, Azure Functions, Azure DevOps Services, Git, Real-time Streaming Analytics.
              "
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={osaka_expo}
              isBlog={false}
              title="Crowd Monitoring and Forecasting in Osaka Expo 2025"
              description="This application is designed to monitor and analyze crowd flow at the site of the Osaka Expo event. It leverages a combination of AI-enabled cameras and smart beacons to ensure a safe, efficient, and seamless experience for visitors, staff, and logistics teams by preventing overcrowding and improving movement coordination.

              Key Features
              #Real-Time Monitoring: Continuously tracks visitor inflow and outflow through multiple entry/exit points using synchronized data from live cameras and Bluetooth beacons.

              #Capacity Management & Alerting: Each gate is assigned a predefined capacity threshold. When the number of people approaches or exceeds the limit, automatic alerts are dispatched to event organizers, security teams, and on-site supervisors to take timely action.

              #Predictive Forecasting: The system combines real-time sensor data with historical patterns to forecast crowd density at each gate throughout the day, allowing for proactive crowd control.

              #Time-Based Insights: Analyzes crowd movement across different time intervals to identify peak hours, enabling better planning for staffing, resource allocation, and logistics.

              #Actionable Intelligence for Stakeholders: Delivers real-time recommendations and instructions to various stakeholders (organizers, volunteers, logistics coordinators) to:
              a) Redirect visitors to less congested gates
              b) Allocate staff/volunteers where they are most needed
              c) Designate gates for logistics and transport without disrupting visitor movement
              
              *Technologies used in the project - Python, pandas, JavaScript, TypeScript,  Next.js, D3.js, Plotly.js, SQL, MySQL, ARIMA model, AI Cameras & AI Beacons (IoT), Azure Functions, Azure App Services, Azure Blob Storage, Azure AD B2C, Azure DevOps Services, Git"
              
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={interest_detection}
              isBlog={false}
              title="Group Detection & Action Analysis in Crowd using Skeletal Data"
              description="This project focused on developing a machine learning-based system to detect human groups and analyze their engagement levels in crowded environments using skeletal pose data.

              Key Features:
              #Pose Detection with Movenet: Video footage from public places like stores, shops, and exhibitions was processed to extract 2D skeletal data (17 keypoints per person) along with individual tracking IDs.
              
              #Group Detection Algorithm: Designed a custom ML algorithm to detect which individuals belong to the same group based on their pose, proximity, and orientation.
              
              #Interest & Engagement Analysis: The system determined group sizes, whether members were conversing, their level of excitement, and overall group dynamics.
              
              #Visual Analytics in Power BI: Created rich visual dashboards in Power BI showing insights like: Number of groups over time, Distribution of group sizes, Number of conversing or excited individuals, Temporal trends in group behaviors. 
              
              *Technologies used in the project - Python, PySpark, pandas, Matplotlib, Scikit-Learn, OpenCV, Movenet, MMPose, Azure Databricks, Azure Blob Storage, MySQL, Spark SQL, Power BI, Docker, Git.
              "
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={group_judge}
              isBlog={false}
              title="Customer Interest Area Detection using Skeletal Pose Data"
              description="This project aimed to identify the most engaging or attractive areas in physical spaces like stores, exhibitions, and retail environments by analyzing human pose and gaze direction.
              
              Key Features:
              #Skeletal Data Extraction with Movenet: Captured 2D skeletal data (17 body keypoints) from video footage using Movenet, along with tracking IDs for each person.
              
              #Interest Area Detection Algorithm: Developed an ML algorithm to determine where individuals were focusing their attention based on head direction and proximity, identifying which objects or zones people looked at directly or closely.
              
              #Object Popularity Insights: Aggregated interest data to generate statistics on which items or areas drew the most attention from visitors.
              
              #Data-Driven Decision Support: Helped businesses and event organizers optimize product placements or exhibit arrangements based on real visitor behavior.
              
              *Technologies Used: Python, PySpark, pandas, Matplotlib, Scikit-Learn, OpenCV, Movenet, MMPose, Azure Databricks, Azure Blob Storage, MySQL, Spark SQL, Power BI, Docker, Git."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bi_bot}
              isBlog={false}
              title="Business Intelligence Bot"
              description="This project delivers a generative AI-powered Business Intelligence Chatbot designed to simplify complex data analysis and reporting through natural language interaction and dynamic visualizations. The system enables users to query business metrics and KPIs using everyday natural language and receive instant responses in the form of clear, interactive charts, graphs, and data tables—transforming raw data into actionable insights.

              Key Features:
              #Natural Language Interface: Allows users to ask questions in plain language (e.g., “What were our top 5 products last quarter with the investment cost of each?”), eliminating the need for technical knowledge of SQL or dashboard tools.

              #Advanced Visual Analytics: Presents responses through a wide range of interactive visual formats—such as data tables, bar charts, stacked bar charts, heatmaps, line graphs, pie charts, and more—enabling intuitive understanding and faster decision-making.

              #NER & Query Generation with LangChain: Integrates Named Entity Recognition (NER) to extract key components from user queries and uses LangChain to dynamically generate accurate and context-aware database queries.

              #Real-Time Database Integration: Connects to storage databases to retrieve and analyze both real-time and historical business data, ensuring the insights are current and relevant.

              #Multi-Agent Architecture: Implements a multi-agent system to manage various tasks—such as intent recognition, query formulation, data retrieval, and visualization generation—in parallel, significantly enhancing speed and system responsiveness.

              #Streamlit-Based Web Interface: Built with Streamlit, the system provides a clean, interactive, and responsive front-end, allowing users to seamlessly interact with data and receive visual feedback in real time.

              *Technologies used in the project -  Python, NumPy, pandas, Plotly, Dask, LangChain, Large Language Models (LLM), OpenAI API, Anthropic Claude, LLaMA, Streamlit, SQLAlchemy, PostgreSQL, Google BigQuery, Docker, Git, CI/CD, Jira.
              "
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={apache_superset}
              isBlog={false}
              title="ETL & BI"
              description="This project involved building a comprehensive Business Intelligence (BI) solution to support data-driven decision-making across multiple business domains. We developed robust data pipelines to ingest, process, and visualize data from a variety of sources.

              Key Features:
              #Data Ingestion from Multiple Sources: Integrated data from partner APIs, Google BigQuery, Google Ads, PageInsights, internal inventory APIs, and business systems.
              
              #Scalable ETL Pipelines: Used AWS Glue and AWS Batch to build scalable and automated ETL processes, transforming raw data into structured formats.
              
              #Centralized Data Storage: Processed data was stored in a PostgreSQL database, optimized for querying and analytics.
              Dynamic Dashboards: Over 30+ interactive dashboards were created in Apache Superset, where more than 2000 analytical formulas used for data visualization, each dedicated to a specific domain (e.g., marketing, sales, inventory).
              
              #Real-Time Visual Insights: Dashboards featured a wide range of analytical charts and graphs, which automatically updated with every data load cycle. 
              
              *Technologies used in the project - Python, pandas, NumPy, pytest, PySpark, AWS Glue, Apache Airflow, Google BigQuery, Amazon Relational Database Service (RDS), Elasticsearch, Data Build Tool (DBT), Google Analytics 4, SQLAlchemy, PostgreSQL, Docker, Git, Apache Superset, Power BI, Jira."
              // ghLink="https://github.com/Akash-Debnath/SEMS"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={automation}
              isBlog={false}
              title="Data Pipeline Monitoring & Automation System"
              description="This project was developed as an extension of a BI platform to ensure the reliability, accuracy, and performance of data pipelines. It focused on automating the monitoring and validation of ETL workflows.

              Key Features:
              Automated Pipeline Testing: Continuously tested the status and integrity of data pipelines, checking for failures, anomalies, or data inconsistencies.
              Intelligent Alerting System: Automatically detected abnormal behavior (e.g., missing data, schema mismatches, or delays) and sent real-time alerts to Microsoft Teams and Slack, with detailed diagnostics.
              Custom Web Dashboard: Built using Flask and SQLAlchemy, providing a lightweight interface for monitoring logs and alerts.
              Database Integration: Utilized PostgreSQL for storing test results, historical logs, and anomaly records. Technologies used 
              in the project - Python, Flask, SQLAlchemy."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sems}
              isBlog={false}
              title="SEMS"
              description="Smart Employee Management System an advanced digital solution designed to streamline 
              and optimize various aspects of employee administration within an organization. Technologies used 
              in the project - PHP, Laravel, HTML, CSS, SASS, Bootstrap, Javascript, AJAX, jQuery, Eloquent, MySQL."
              ghLink="https://github.com/Akash-Debnath/SEMS"
              demoLink="https://www.youtube.com/watch?v=S4uZ-LeMSII&list=PLBragTtHHO7rA6EPRP8YbVQTVeQliucVB&index=1&t=125s"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={newsportal}
              isBlog={false}
              title="News Portal"
              description="The most significant part of this system is, it has a secure
              recommendation system which is developed and architectured by the concept of federated learning with defending against
              model poisoning attacks. I termed this secure algorithm as “FedLearntRecommender”. Technologies used 
              in the project - Python (API), PHP, Laravel, Javascript, HTML, CSS, Tailwind, Bootstrap, jQuery, Livewire, Eloquent."
              ghLink="https://github.com/Akash-Debnath/News-Portal-FedLearntRecommender"
              demoLink="https://www.youtube.com/watch?v=dYTpihcaDWc&list=PLBragTtHHO7rA6EPRP8YbVQTVeQliucVB&index=2&t=2s"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kbs}
              isBlog={false}
              title="KBS"
              description="Knowledge Based System was developed for IFIC Bank which is built for an online exam system
              for their employees and basic info and updated news/blogs for their clients. Technologies used in the project - PHP, Laravel, Javascript, 
              Vuejs, HTML, CSS, SASS, Bootstrap, jQuery, Eloquent."
              ghLink="https://github.com/Akash-Debnath/KBS/tree/master"
              demoLink="https://kbs.gplex.com/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={streamz}
              isBlog={false}
              title="Streamz"
              description="Streamz boasts an intuitive and user-friendly interface, allowing users to explore an extensive library 
              of songs, albums, and playlists. Its powerful algorithms enable personalized content recommendations, creating custom 
              playlists tailored to individual preferences. Users can also engage in social interactions by sharing with friends. 
              Admin can CRUD albums, songs and playlists. Moreover, admin can customize anything of the client sites. 
              Users can check host property and rooms to take rent for a time period, then they can proceed for payment by card. 
              Site fvicons to footer links/pages everything is customized and inserted by admin. Technologies used in the 
              project - PHP, JavaScript, HTML, CSS, Bootstrap, Ajax, ORM, MySQL.
              
              Admin Site: https://streamz.theme1.w3engineers.com/admin (user: admin@gmail.com, Password: 123456)"
              
              // ghLink="">
              demoLink="https://streamz.theme1.w3engineers.com/"
              // demoLink2="https://streamz.theme1.w3engineers.com/admin"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath= {myproperty}
              isBlog={false}
              title="My Property"
              description="Its a home rental/booking system which is a web application. There've two panel - admin and user. 
              From the user's perspective, the platform allows individuals to seamlessly explore available properties and rooms
              for rent. Users can browse through a variety of options, gaining insights into property details, amenities, and 
              pricing. The booking process is streamlined, enabling users to select their desired time period and proceed with 
              secure online payments using credit cards.Admins can customize every aspect, from the site's favicon to footer links 
              and pages, ensuring a branded and tailored experience. Property listings and details are managed by the admin, ensuring 
              accuracy and relevance. The payment system is secure and integrated, facilitating smooth transactions between users and 
              hosts. Technologies used in the project - PHP, JavaScript, HTML, CSS, Bootstrap, Ajax, ORM, MySQL."
              // ghLink=""
              demoLink="https://www.youtube.com/watch?v=5AFhpS8rhNw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={robi}
              isBlog={false}
              title="Robi-Airtel SocialMiner"
              description="This advanced application serves as a powerful tool for businesses, enabling them to streamline the management 
              of their Instagram and Facebook messages and comments. The centralized and user-friendly dashboard provides organizations with 
              an intuitive interface to effectively oversee, respond to, and analyze their social media interactions. This comprehensive approach 
              enhances customer satisfaction and fosters brand loyalty by offering businesses a seamless platform to engage with their audience. 
              From monitoring messages to efficiently handling comments, the application facilitates a cohesive social media management experience, 
              ultimately contributing to the overall success and positive perception of the brand. Technologies used in the project - PHP, CodeIgniter, 
              JavaScript, HTML, CSS, Bootstrap, Ajax, MySQL."
              ghLink="https://github.com/Akash-Debnath/Robi-Airtel-Socialminer"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eshop}
              isBlog={false}
              title="Eshop"
              description="Basically its a ecommerce platform web application. There've two panel - admin and user. 
              User can search product as name or category, add to cart, then proceed for payment (bKash, Nagad, Rocket). 
              Admin can accept user order, add, edit, place products, answer if user have 
              any query and so on. Technologies used in the project - PHP, JavaScript, HTML, CSS, Bootstrap, Ajax, MySQL."
              ghLink="https://github.com/Akash-Debnath/E-shop/tree/master"
              // demoLink=""
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ncr}
              isBlog={false}
              title="NCR"
              description="NSTU Course Registration(NCR) aimed to facilitate course registration (physical to online) for Noakhali Science 
              and Technology University(NSTU). It has seven portals for the education branch, chairman, course coordinator, section officer, 
              hall provost, registrar, and student. Technologies used in the project - PHP, JavaScript, HTML, CSS, Bootstrap, MySQL."
              ghLink="https://github.com/Akash-Debnath/NSTU-Course_Registration/tree/master"
              // demoLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={flappybird}
              isBlog={false}
              title="Flappy Bird"
              description="Flappy Bird is a desktop game application. It was available as an android application 
              so we make the desktop version of this application. Technologies used in the project - Java"
              ghLink="https://github.com/Akash-Debnath/flappy-bird/tree/master"
              // demoLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ums}
              isBlog={false}
              title="UMS"
              description="University Management System created a comprehensive and efficient digital solution 
              to streamline administrative, academic, and operational processes within a universityTechnologies 
              used in the project - PHP, Laravel, Javascript, HTML, CSS, Bootstrap, jQuery, Eloquent."
              ghLink="https://github.com/Akash-Debnath/University_Management_System/tree/master"
              // demoLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lan}
              isBlog={false}
              title="Lan chat and file sharing"
              description="This project developed for sending files or information
              without using the internet for confidentiality and integrity but within same Local Area Network (LAN). Firstly, everyone in 
              the institute has to register and they will log in through their username/email and password. They’re able to chat in a group 
              or privately with an individual. Anyone can send files and the receiver(s) are able to download these files. Technologies used 
              in the project - Java, JSP, Servlet, Tomcat library, and MySQL"
              ghLink="https://github.com/Akash-Debnath/Lan-Chat-and-File-Sharing"
              // demoLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={recruitment}
              isBlog={false}
              title="HR Recruitment"
              description="This is the module of a full package Human Resource system. The recruitment module 
              handles all of the procedures related to recruitment. Job circular to meeting schedule and selection 
              everything can manage with it. Technologies used 
              in the project - PHP, CodeIgniter, Javascript, HTML, CSS, Bootstrap, AJAX, jQuery, MySQL"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
